<footer class="footer">
  <app-log-viewer #logViewer></app-log-viewer>

  <div class="footer__gradient-bar"></div>

  <div class="footer__body">
    <div class="footer__container">

      <!-- Brand -->
      <div class="footer__brand">
        <div class="footer__logo"  (click)="onOpenLogViewer()">
          <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="18" cy="18" r="17" stroke="url(#grad)" stroke-width="2"/>
            <circle cx="18" cy="18" r="8" fill="url(#grad)" opacity="0.2"/>
            <line x1="18" y1="4" x2="18" y2="32" stroke="url(#grad)" stroke-width="1.5"/>
            <line x1="4" y1="18" x2="32" y2="18" stroke="url(#grad)" stroke-width="1.5"/>
            <circle cx="18" cy="18" r="3" fill="url(#grad)"/>
            <defs>
              <linearGradient id="grad" x1="0" y1="0" x2="36" y2="36" gradientUnits="userSpaceOnUse">
                <stop offset="0%" stop-color="#6B5CE7"/>
                <stop offset="100%" stop-color="#2D8EFF"/>
              </linearGradient>
            </defs>
          </svg>
          <span class="footer__logo-text">Referio</span>
        </div>
        <p class="footer__tagline">
          L'annuaire qui rend les professionnels<br>visibles <span class="footer__tagline--accent">en un clic</span>.
        </p>
      </div>

      <!-- Navigation -->
      <div class="footer__col">
        <h4 class="footer__col-title">Navigation</h4>
        <ul class="footer__links">
          <li *ngFor="let item of navigation">
            <a [routerLink]="item.route" class="footer__link">{{ item.label }}</a>
          </li>
        </ul>
      </div>

      <!-- Legal -->
      <div class="footer__col">
        <h4 class="footer__col-title">Informations</h4>
        <ul class="footer__links">
          <li *ngFor="let item of legal">
            <a [routerLink]="item.route" class="footer__link">{{ item.label }}</a>
          </li>
        </ul>
      </div>

      <!-- Contact CTA -->
      <div class="footer__col footer__col--cta">
        <h4 class="footer__col-title">Besoin d'aide ?</h4>
        <p class="footer__cta-text">Notre équipe est disponible pour répondre à toutes vos questions.</p>
        <a routerLink="/contact" class="footer__btn">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
          </svg>
          Nous contacter
        </a>
      </div>

    </div>
  </div>

  <!-- Bottom bar -->
  <div class="footer__bottom">
    <div class="footer__bottom-inner">
      <span class="footer__copyright">
        &copy; {{ currentYear }} Referio. Tous droits réservés.
      </span>
      <div class="footer__bottom-links">
        <a routerLink="/mentions-legales" class="footer__bottom-link">Mentions légales</a>
        <span class="footer__separator">·</span>
        <a routerLink="/politique-confidentialite" class="footer__bottom-link">Confidentialité</a>
      </div>
    </div>
  </div>
</footer>